import {useContext} from 'react'
import PredefinedDateRange from '../../../../components/DateRangePicker/PreDefinedDateRange'
import {CouponCodeReportContext} from '../../context'
import Search from '../../../../components/Search'
import Import from '../../../../images/Import.png'
import {useState} from 'react'
import {ConfirmationModal} from '../../../../components/ConfirmationModal'
import { MIN_DATE_RANGE } from '../../utils'

const CouponCodeReportHeader = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const [message, setMessage] = useState('')
  const dateRangeLabel = localStorage.getItem('dateRangeLabel')
  const {reportData, filters, onSearch, handleCouponCodeReportDateChange, onDownloadCsv} =
    useContext(CouponCodeReportContext)

  const handleDownLoadCSV = async () => {
    setIsLoading(true)

    const res = await onDownloadCsv(filters)
    if (res !== '') {
      setShowModal(true)
      setMessage(res)
    }
  }

  return (
    <>
      <div className='d-flex justify-content-between align-items-center mb-10'>
        <div className='d-flex align-items-center'>
          <div>
            <Search
              onSearch={(searchTerm: string) => {
                onSearch && onSearch(searchTerm)
              }}
              placeholder='Search coupon code'
              defaultValue={filters.search}
            />
          </div>
        </div>
        <div className='d-flex align-items-center gap-5'>
          <button
            className='btn btn-outline d-none'
            onClick={handleDownLoadCSV}
            disabled={isLoading || !reportData?.length}
          >
            <div className='d-flex align-items-center'>
              <img src={Import} alt='Import File' className='me-2 import-icon' />
              <div className='d-flex align-items-center'>
                {isLoading ? 'Downloading...' : 'Export CSV'}
                {isLoading && (
                  <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                )}
              </div>
            </div>
          </button>
          <div className='me-5'>
            <PredefinedDateRange
              cb={handleCouponCodeReportDateChange}
              defaultValue={dateRangeLabel || 'Last 90 Days'}
              includeCurrantDay
              startDate={MIN_DATE_RANGE}
            />
          </div>
        </div>
      </div>

      <ConfirmationModal
        show={showModal}
        onClose={() => {
          setShowModal(false)
          setMessage('')
        }}
        title={'Generating Your CSV File'}
        disableAction={true}
        onAction={() => {
          setShowModal(false)
          setMessage('')
        }}
        okayBtnClass={'btn-primary'}
        body={
          <div>
            <p>We are generating the data you requested for download as a CSV file.</p>
            <p>
              This process may take a few minutes. Once complete, the CSV will be sent to your
              email: <b>{message.split(':')[1]}</b>
            </p>
          </div>
        }
      />
    </>
  )
}

export default CouponCodeReportHeader
